import axios from 'api/config'

const getToken = () => {
    var Labtoken = localStorage.getItem('Labtoken');
    return Labtoken ? Labtoken : ''
}

const ajax = async (url, params = {}, type = 'get') => {
    var Labtoken = getToken()
    const token = Labtoken ? {Labtoken: Labtoken} : {}
    if (type === 'get' || type === 'GET') {
        const res = await axios.get(url, { params: Object.assign(params, token) })
        return res.data
    } else if (type === 'post' || type === 'POST') {
        // axios.defaults.headers['content-type'] = 'application/json;'
        // const res = await axios.post(url, Object.assign(params, token))
        // console.log(params)console.log(Object.assign(params, token))
        // const res = await axios.post(url, Object.assign(params, token))
        const res = await axios.post(url, Object.assign(params))
        return res.data
    }
}
export default ajax
